
import axiosInstance from '../../../../config/axiosInstance';
import { ReportValidation } from "../../views/Report/Validation/ReportValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
  
  event.preventDefault();
  debugger;
  const formErrors =await ReportValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      
      const token = localStorage.getItem('token');
      if (!token || token=="null") {
          redirectCallback();
          return; // Return early to prevent further execution
      }
      const response = await axiosInstance.post(`/Setup/CreateJasperReport`, formData);
      return response;
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
  
};

export { handleChange, handleSubmit };